import React from "react";
import { gql, useQuery } from "@apollo/client";
import InfiniteScroll from "react-infinite-scroll-component";

import {
  Container,
  List,
  Tooltip,
  Fab,
  FormControl,
  FormControlLabel,
  Switch,
  Stack,
  Typography,
} from "@mui/material";
import { Plus as CreateIcon } from "mdi-material-ui";

import Layout from "components/common/Layout";
import SearchInput from "components/common/SearchInput";
import DiscountCodesListItem from "components/discountCode/DiscountCodesListItem";
import CreateDiscountCode from "components/discountCode/CreateDiscountCode";

const QUERY = gql`
  query ($first: Int, $after: String, $search: String, $onlyActive: Boolean) {
    discountCodes(
      first: $first
      after: $after
      search: $search
      onlyActive: $onlyActive
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }

      edges {
        cursor
        node {
          id

          ...DiscountCodesListItem_discountCode
        }
      }
    }
  }

  ${DiscountCodesListItem.fragments.discountCode}
`;

export default function DiscountCodesPage() {
  const [search, setSearch] = React.useState("");
  const [onlyActive, setOnlyActive] = React.useState(true);

  const { data, loading, fetchMore, refetch } = useQuery(QUERY, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
    variables: { first: 20, search, onlyActive },
  });

  return (
    <Container fixed>
      <Layout.Toolbar fixed>
        <Stack spacing={2} direction="row" alignItems="center">
          <CreateDiscountCode onSubmitted={() => refetch()}>
            {({ open }) => (
              <Tooltip placement="top" title="Créer un code de réduction">
                <Fab onClick={open} size="small" color="primary">
                  <CreateIcon />
                </Fab>
              </Tooltip>
            )}
          </CreateDiscountCode>

          <Typography variant="h4" color="primary" sx={{ flexGrow: 1 }}>
            Codes de réductions
          </Typography>

          <Stack spacing={1}>
            <SearchInput
              onChange={setSearch}
              FormHelperTextProps={{ component: "div" }}
            />

            <FormControl fullWidth={false}>
              <FormControlLabel
                label="Afficher uniquement les codes utilisables"
                control={
                  <Switch
                    checked={onlyActive}
                    onChange={(evt, val) => setOnlyActive(val)}
                  />
                }
              />
            </FormControl>
          </Stack>
        </Stack>
      </Layout.Toolbar>

      <List>
        <InfiniteScroll
          scrollableTarget="Layout-Main"
          dataLength={data?.discountCodes.edges.length ?? 0}
          next={() =>
            fetchMore({
              variables: { after: data?.discountCodes.pageInfo.endCursor },
            })
          }
          loader={<Layout.Loading />}
          hasMore={data?.discountCodes.pageInfo.hasNextPage ?? loading}
        >
          {data?.discountCodes.edges.map(({ cursor, node }) => (
            <DiscountCodesListItem
              key={cursor}
              discountCode={node}
              onDelete={refetch}
            />
          ))}
        </InfiniteScroll>
      </List>
    </Container>
  );
}
